<template>
  <div class="modal fade py-1" id="mod-product-add" role="dialog">
    <div class="modal-dialog mx-auto">
      <form @submit.prevent="submit" class="modal-content p-[24px] bg-[#f8f8f8]">
        <div class="modal-header flex items-start justify-between p-0 m-0">
          <h4 class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]">
            {{ isEdit ? "Update Item" : "Add Item" }}
          </h4>
          <button class="text-2xl text-[#353535]" type="button" data-dismiss="modal" aria-hidden="true" @click="cancel">
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div v-if="false">{{ purchaseOrder }}</div>
        <div class="modal-body m-0 p-0">
          <div v-for="(item, index) in newItems" :key="item.uniqueId">
            <div>
              <div class="mb-[16px]">
                <label class="text-[#353535] font-bold-500 text-[14px] leading-[20px]">
                  Select product
                </label>
                <div>
                  <select :disabled="isEdit"
                    class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full"
                    :class="{
                      'is-invalid': $v.newItems.$each[index].productId.$error,
                    }" v-model="item.productId" @change="setProduct($event.target.value, index)"
                    placeholder="Select a product">
                    <option value="" selected disabled>Select a product</option>
                    <option v-for="p in preparedProducts" :key="p.id" :value="p.id">
                      {{ p.name }}
                    </option>
                  </select>
                  <span class="invalid-feedback" v-if="$v.newItems.$each[index].productId.$error">
                    Please select a product
                  </span>
                </div>
              </div>
              <div class="mb-[16px]">
                <label class="text-[#353535] font-bold-500 text-[14px] leading-[20px]">
                  Quantity
                </label>
                <div>
                  <div v-if="item.minimumOrderQuantity > 0">
                    <div class="flex items-center gap-[5px]">
                      <input
                        class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-[85%]"
                        :class="{
                          'is-invalid':
                            $v.newItems.$each[index].quantity.$error,
                        }" type="number" readonly placeholder="Enter the quantity you needed"
                        v-model.number="item.quantity" />
                      <div class="flex items-center gap-[5px] w-[15%]">
                        <span
                          class="fa-solid fa-plus text-[16px] text-[#353535] border-[1.5px] border-solid border-[#666] rounded-full p-[5px] cursor-pointer"
                          @click="incrementQuantity(index)"></span>
                        <span
                          class="fa-solid fa-minus text-[16px] text-[#353535] border-[1.5px] border-solid border-[#666] rounded-full p-[5px]"
                          :class="{
                            'cursor-not-allowed text-gray-400':
                              item.quantity <= item.minimumOrderQuantity,
                            'cursor-pointer':
                              item.quantity > item.minimumOrderQuantity,
                          }" @click="decrementQuantity(index)"></span>
                      </div>
                    </div>
                    <p>
                      This product has a minimum order quantity of
                      {{ item.minimumOrderQuantity }}/{{ item.unit }}
                    </p>
                    <p>
                      This quantity can only be increased by
                      {{ item.incrementalQuantity }}/{{ item.unit }}
                    </p>
                  </div>
                  <div v-else>
                    <input
                      class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full"
                      :class="{
                        'is-invalid': $v.newItems.$each[index].quantity.$error,
                      }" type="number" placeholder="Enter the quantity you needed" v-model.number="item.quantity" />
                    <span class="invalid-feedback" v-if="$v.newItems.$each[index].quantity.$error">
                      Please enter a valid quantity
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center gap-[8px] mt-[16px]">
          <button
            class="border-[#96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
            type="button" data-dismiss="modal" @click="cancel">
            Cancel
          </button>
          <button :disabled="isBusyModal || isSubmitDisabled"
            class="bg-[#2463eb] border-[#2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full disabled:cursor-not-allowed"
            type="submit">
            <span v-if="isLoading">Loading...</span>
            <span v-else-if="isEdit">Update Item</span>
            <span v-else>Add Item</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import { bus } from "../../main";

export default {
  name: "AddItem",
  props: {
    edit: {
      type: Object,
      default: null,
    },
    groupId: {
      type: String,
      required: true,
    },
    products: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    purchaseOrder: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isBusyModal: false,
      newItems: [this.getEmptyItem()],
    };
  },
  computed: {
    preparedProducts() {
      if (!this.purchaseOrder || !this.purchaseOrder.parent) {
        return [];
      }
      const { sapPriceGroup } = this.purchaseOrder.parent;
      let filteredProducts = this.products.filter((product) => {
        const isActive = product.active;
        const division = product.sapDivision;
        switch (sapPriceGroup) {
          case 'P1':
            return isActive && division !== '10';
          case 'P2':
            return isActive && division === '10';
          case 'P3':
            return isActive;
          default:
            return isActive;
        }
      });

      return filteredProducts.filter((product) => {
        if (this.isEdit) {
          return !this.items.some(
            (item) =>
              item.id === product.id && item.id !== this.newItems[0].productId
          );
        }
        return !this.items.some((item) => item.id === product.id);
      });
    },
    isSubmitDisabled() {
      return this.newItems.some(
        (item) =>
          item.loading ||
          item.quantity <= 0 ||
          !item.productId
      );
    },
    isLoading() {
      return this.newItems.some((item) => item.loading);
    },
    isEdit() {
      return this.edit !== null;
    },
  },

  validations: {
    newItems: {
      $each: {
        productId: { required },
        quantity: {
          required,
          minValue: minValue(1),
        },
      },
    },
  },

  watch: {
    edit: {
      immediate: true,
      handler(value) {
        if (value) {
          this.newItems = [{
            ...this.getEmptyItem(),
            ...value,
          }];
          if (value.productId) {
            this.setProduct(value.productId, 0);
          }
        }
      },
    },
  },
  methods: {
    getEmptyItem() {
      return {
        productId: "",
        productCode: "",
        quantity: 0,
        productName: "",
        minimumOrderQuantity: 0,
        incrementalQuantity: 1,
        unit: "",
        loading: false,
        uniqueId: Math.floor(Math.random() * 76528752387437484) + 108833,
      };
    },

    incrementQuantity(index) {
      const item = this.newItems[index];
      if (item) {
        item.quantity += item.incrementalQuantity;
      }
    },

    decrementQuantity(index) {
      const item = this.newItems[index];
      if (item && item.quantity > item.minimumOrderQuantity) {
        item.quantity -= item.incrementalQuantity;
      }
    },

    setProduct(productId, index) {
      const product = this.products.find((product) => product.id === productId);
      if (!product) return;

      const minimumOrderQuantity = Number(product.minimumOrderQuantity || 0);
      const incrementalQuantity = Number(product.incrementalQuantity || 1);
      const isEditing = !!this.newItems[index].productId;
      const previousQuantity = this.isEdit
        ? this.newItems[index].quantity
        : minimumOrderQuantity;

      Object.assign(this.newItems[index], {
        productCode: product.code,
        productId: product.id,
        productName: product.name,
        minimumOrderQuantity,
        incrementalQuantity,
        unit: product.unit,
        quantity: previousQuantity,
        productTax: product.sapTaxClassification,
      });
    },

    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      if (this.isEdit) {
        this.$emit("onItemUpdated", { ...this.newItems[0] });
      } else {
        this.$emit("onItemAdded", { ...this.newItems[0] });
      }
      this.reset();
    },

    reset() {
      this.newItems = [this.getEmptyItem()];
      this.$v.$reset();
    },

    cancel() {
      this.reset();
      this.$emit("cancel");
    },
  },
};
</script>